import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const ArrowIcon = (props) => (
    <SvgIcon {...props}>
        <svg
            width="13"
            height="11"
            viewBox="0 0 13 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 5.5H11.8M1 5.5L5.5 1M1 5.5L5.5 10"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke="black"
            />
        </svg>
    </SvgIcon>
);

export default ArrowIcon;
